import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import MenuButton from "../../components/MenuButton/MenuButton";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import { ACCOUNT_VERIFY_TYPES } from "../../config/setting";
import "../../styles/globals.css";
import "./AccountVerifyPage.css";

/**
 * アカウント確認画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function AccountVerifyPage() {
  const { globalMedicalInstitutionName, setGlobalSelectAccountVerify } =
    useContext(AppContext);
  const navigate = useNavigate();

  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {}, []);

  /**
   * メニューボタンクリック時
   * @param {ACCOUNT_VERIFY_TYPES} type - アカウントの有無
   * @return {}  なし
   */
  const handleMenuClick = (type) => {
    // 保持
    setGlobalSelectAccountVerify(type);

    // アカウントありの場合
    if (type === ACCOUNT_VERIFY_TYPES.HAS_ACCOUNT) {
      // ログイン画面に遷移
      navigate("/account-login");
    } else {
      // 予約情報入力画面に遷移
      navigate("/reservation-entry");
    }
  };

  /**
   * 戻るボタンクリック時
   * @param {} なし
   * @return {}  なし
   */
  const handleBackClick = () => {
    // 日時選択画面に遷移
    navigate("/datetime-select");
  };

  return (
    <div className="account-verify">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      <div className="main-area">
        <div className="title">アカウントの確認</div>
        <div className="detail">ウィーメックスアカウントをお持ちですか？</div>
        <div className="menu-buttons">
          <MenuButton
            key={1}
            className="menu-button"
            topSubLabel="持っている"
            buttonLabel={"ウィーメックスアカウントでログイン"}
            onClick={() => handleMenuClick(ACCOUNT_VERIFY_TYPES.HAS_ACCOUNT)}
          />
          <MenuButton
            key={2}
            className="menu-button"
            topSubLabel="持っていない"
            buttonLabel={"アカウントなしで進む"}
            onClick={() => handleMenuClick(ACCOUNT_VERIFY_TYPES.NO_ACCOUNT)}
          />
        </div>
        <GeneralButton
          buttonLabel={"日時選択に戻る"}
          type={"secondary-white"}
          onClick={() => handleBackClick()}
        />
      </div>
    </div>
  );
}

export default AccountVerifyPage;
